export default __webpack_public_path__ + "static/media/Martin.65a2fcf0.JPG";